import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type Props = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  busy?: boolean;
  busyLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
  /** "primary" for a confirmed step that is not a removal (a forward step, an allotment). */
  tone?: "danger" | "primary";
};

/** Shared confirmation shell for destructive actions. Retains the existing Reactstrap modal styling. */
const HKPConfirmDialog = ({ open, title, description, confirmLabel, busy = false, busyLabel = "Removing…", onCancel, onConfirm, tone = "danger" }: Props) => (
  <Modal isOpen={open} toggle={busy ? undefined : onCancel} centered aria-labelledby="hkp-confirm-title">
    <ModalHeader toggle={busy ? undefined : onCancel}>
      <span id="hkp-confirm-title">{title}</span>
    </ModalHeader>
    <ModalBody>{description}</ModalBody>
    <ModalFooter>
      <Button type="button" outline onClick={onCancel} disabled={busy}>Cancel</Button>
      <Button type="button" color={tone} onClick={onConfirm} disabled={busy} aria-busy={busy}>
        {busy ? busyLabel : confirmLabel}
      </Button>
    </ModalFooter>
  </Modal>
);

export default HKPConfirmDialog;
